import ShopOrderItemResourceModel from '../../generated/types/model/resource/ShopOrderItemResourceModel';

export default class ShopOrderItemResourceViewModel extends ShopOrderItemResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
